module.exports = __webpack_public_path__ + "img/syukyaku-top-008.f5e96dd5.jpg";